import { render, staticRenderFns } from "./404.vue?vue&type=template&id=6cb432d8&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=6cb432d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb432d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb432d8')) {
      api.createRecord('6cb432d8', component.options)
    } else {
      api.reload('6cb432d8', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=6cb432d8&scoped=true", function () {
      api.rerender('6cb432d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/error-page/404.vue"
export default component.exports